import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { map } from 'rxjs';

import { PaymentPageComponent } from './payment-page.component';

@Injectable({ providedIn: 'root' })
export class PaymentPageDeactivateGuard implements CanDeactivate<PaymentPageComponent> {
  canDeactivate(component: PaymentPageComponent) {
    return component?.isPartiallyPaid$.pipe(
      map((isPartiallyPaid) => !isPartiallyPaid || component.internalStep === 'variant')
    );
  }
}
